import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import LoginPanel from './LoginPanel';
import LogoutConfirmModal from './LogoutConfirmModal';
import { useAuth } from '../admin/AuthContext';

const MainLayout = () => {
  const [isLoginPanelOpen, setLoginPanelOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const { logout } = useAuth();

  const handleLoginClick = () => {
    setLoginPanelOpen(true);
  };

  const handleCloseLoginPanel = () => {
    setLoginPanelOpen(false);
  };

  // 사이드바에서 "로그아웃" 클릭 시: 패널 닫고 로그아웃 확인 모달만 표시
  const handleRequestLogout = () => {
    setLoginPanelOpen(false);
    setShowLogoutConfirm(true);
  };

  const handleConfirmLogout = () => {
    setShowLogoutConfirm(false);
    logout();
  };

  useEffect(() => {
    const handleOpenLoginPanel = () => setLoginPanelOpen(true);
    window.addEventListener('openLoginPanel', handleOpenLoginPanel);
    return () => window.removeEventListener('openLoginPanel', handleOpenLoginPanel);
  }, []);

  return (
    <div className="main-layout-container">
      <Header onLoginClick={handleLoginClick} />
      <main><Outlet /></main>
      <Footer />
      {isLoginPanelOpen && (
        <LoginPanel
          key="login-panel"
          onClose={handleCloseLoginPanel}
          onRequestLogout={handleRequestLogout}
        />
      )}
      <LogoutConfirmModal
        isOpen={showLogoutConfirm}
        onClose={() => setShowLogoutConfirm(false)}
        onConfirm={handleConfirmLogout}
      />
    </div>
  );
};

export default MainLayout; 